import React, { useState, useContext, useEffect } from "react";

import AdminTopBar from "../Common/AdminTopBar";
import InterfaceMenu from "../Interfaces/InterfaceMenu";
import { api_handler } from "../../services/api";
import { GlobalStateContext } from "../../state/GlobalContextProvider";

const Payments = ({ interface_id }) => {

  const themeState = useContext(GlobalStateContext);
  const [isPISP, setIsPISP] = useState(false);
  const [isPayeeId, setIsPayeeId] = useState(false);
  const [isPayeeInfo, setIsPayeeInfo] = useState(false);
  const [isSortcode, setIsSortcode] = useState(false);
  const [isIban, setIsIban] = useState(false);
  const [isSwiftbic, setIsSwiftbic] = useState(false);
  const [isFuture, setIsFuture] = useState(false);
  const [isRecurring, setIsRecurring] = useState(false);

  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const getInterface = async () => {
      var data = {
        interface_id: interface_id,
      };
      const api_rsp = await api_handler("int-pisp:view", data, "POST");
      setIsPISP(api_rsp.data.is_pisp);
      setIsPayeeId(api_rsp.data.payeeid);
      setIsPayeeInfo(api_rsp.data.payeeinfo);
      setIsSortcode(api_rsp.data.sortcode);
      setIsIban(api_rsp.data.iban);
      setIsSwiftbic(api_rsp.data.swiftbic);
      setIsFuture(api_rsp.data.future);
      setIsRecurring(api_rsp.data.recurring);
      setIsLoaded(true);
    };
    getInterface();
    
  }, [interface_id]);

  const updatePaymentsConfiguration = async (pisp_opt, value) => {

    var data = {};
    if(isLoaded===false){ return false; } 

    if(pisp_opt==='payeeinfo'&& value===false){

      data = {
        interface_id: interface_id,
      };
      data[pisp_opt] = '0';
      data["sortcode"] = '0';
      data["iban"] = '0';
      data["swiftbic"] = '0';

    } else {

    data = {
      interface_id: interface_id,
    };
    data[pisp_opt] = value ? "1" : "0";
    }

    const api_rsp = await api_handler("int-pisp:update", data, "POST");
   // if(api_rsp.code===200) { dispatch({ type: "TRIGGER_TOAST" }) }
    setIsPISP(api_rsp.data.is_pisp);
    setIsPayeeId(api_rsp.data.payeeid);
    setIsPayeeInfo(api_rsp.data.payeeinfo);
    setIsSortcode(api_rsp.data.sortcode);
    setIsIban(api_rsp.data.iban);
    setIsSwiftbic(api_rsp.data.swiftbic);
    setIsFuture(api_rsp.data.future);
    setIsRecurring(api_rsp.data.recurring);
  };

  return (
    <div>
      <AdminTopBar />
      <div className="section__master">
        <div className="grid grid-cols-12 gap-6">
    
          <div className="col-span-12 lg:col-span-12 xxl:col-span-12">
            <div className="Section__body">
              <div className="intro-y box">
                <div className="pt-0 ">
                  <h2 className="font-medium text-base mr-auto w-full">
                    Payment Initiation
                  </h2>

                  <p>
                    A Payment Initiation Service Provider (PISP) is permitted to
                    initiate payments from an account on your system on behalf
                    of a user. A PISP needs a user's explicit consent to do so.
                    The way in which your users provide Payment Initiation
                    Consent is described in more detail in the Integration Guide
                  </p>
                </div>
                <div className={"card mb-5 " + themeState.theme}>
                  <div className="list-group tab-content list-group-flush">
                    <div className="list-group-item list-group-item-action d-flex align-items-center ">
                      <div className="flex list-flex">
                        <div className="d-flex align-items-middle list-item-header">
                          <strong className="text-15pt mr-1">
                            Do you wish to support payments through your open
                            banking gateway?
                          </strong>
                        </div>
                        <div className="text-muted list-item-sub-header"></div>
                      </div>
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={isPISP}
                          id="togBtn"
                          onChange={() =>
                            updatePaymentsConfiguration("pisp", !isPISP)
                          }
                        />
                        <div className="slider round"></div>
                      </label>
                    </div>
                  </div>
                </div>

                {isPISP ? (
                  <div>
                    <p>Payment Schema Options</p>
                    <div className={"card mb-5 " + themeState.theme}>
                      <div className="list-group tab-content list-group-flush">
                        <div
                          className="tab-pane active show fade"
                          id="activity_all"
                        >
                          <div
                            className={
                              "list-group-item list-group-item-action d-flex align-items-center " +
                              themeState.theme
                            }
                          >
                            <div className="flex list-flex">
                              <div className="d-flex align-items-middle list-item-header">
                                <strong className="text-15pt mr-1">
                                  Do you support payments to pre-existing
                                  recipients, identified by an ID?
                                </strong>
                              </div>
                            </div>

                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={isPayeeId}
                                id="togBtn"
                                onChange={() =>
                                  updatePaymentsConfiguration(
                                    "payeeid",
                                    !isPayeeId
                                  )
                                }
                              />
                              <div className="slider round"></div>
                            </label>
                          </div>

                          <div className="list-group-item list-group-item-action d-flex align-items-center ">
                            <div className="flex list-flex">
                              <div className="d-flex align-items-middle list-item-header">
                                <strong className="text-15pt mr-1">
                                  Do you support payments with a new recipient
                                  details specified in the request?
                                </strong>
                              </div>
                            </div>

                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={isPayeeInfo}
                                id="togBtn"
                                onChange={() =>
                                  updatePaymentsConfiguration(
                                    "payeeinfo",
                                    !isPayeeInfo
                                  )
                                }
                              />
                              <div className="slider round"></div>
                            </label>
                          </div>

                          <div className="list-group-item list-group-item-action d-flex align-items-center ">
                            <div className="flex list-flex">
                              <div className="d-flex align-items-middle list-item-header">
                                <strong className="text-15pt mr-1">
                                  Do you accept new recipients using UK bank
                                  account details?
                                </strong>
                              </div>
                            </div>

                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={isSortcode}
                                id="togBtn"
                                onChange={() =>
                                  updatePaymentsConfiguration(
                                    "sortcode",
                                    !isSortcode
                                  )
                                }
                              />
                              <div className="slider round"></div>
                            </label>
                          </div>

                          <div className="list-group-item list-group-item-action d-flex align-items-center ">
                            <div className="flex list-flex">
                              <div className="d-flex align-items-middle list-item-header">
                                <strong className="text-15pt mr-1">
                                  Do you accept new recipients using IBAN
                                  details?
                                </strong>
                              </div>
                            </div>

                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={isIban}
                                id="togBtn"
                                onChange={() =>
                                  updatePaymentsConfiguration("iban", !isIban)
                                }
                              />
                              <div className="slider round"></div>
                            </label>
                          </div>

                          <div className="list-group-item list-group-item-action d-flex align-items-center ">
                            <div className="flex list-flex">
                              <div className="d-flex align-items-middle list-item-header">
                                <strong className="text-15pt mr-1">
                                  Do you accept new recipients using SWIFT/BIC
                                  details?
                                </strong>
                              </div>
                            </div>

                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={isSwiftbic}
                                id="togBtn"
                                onChange={() =>
                                  updatePaymentsConfiguration(
                                    "swiftbic",
                                    !isSwiftbic
                                  )
                                }
                              />
                              <div className="slider round"></div>
                            </label>
                          </div>

                          <div className="list-group-item list-group-item-action d-flex align-items-center ">
                            <div className="flex list-flex">
                              <div className="d-flex align-items-middle list-item-header">
                                <strong className="text-15pt mr-1">
                                  Do you support future dated payments?
                                </strong>
                              </div>
                            </div>

                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={isFuture}
                                id="togBtn"
                                onChange={() =>
                                  updatePaymentsConfiguration(
                                    "future",
                                    !isFuture
                                  )
                                }
                              />
                              <div className="slider round"></div>
                            </label>
                          </div>

                          <div className="list-group-item list-group-item-action d-flex align-items-center ">
                            <div className="flex list-flex">
                              <div className="d-flex align-items-middle list-item-header">
                                <strong className="text-15pt mr-1">
                                  Do you support recurring payments?
                                </strong>
                              </div>
                            </div>

                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={isRecurring}
                                id="togBtn"
                                onChange={() =>
                                  updatePaymentsConfiguration(
                                    "recurring",
                                    !isRecurring
                                  )
                                }
                              />
                              <div className="slider round"></div>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payments;
